(function ($) {
	var containerPaddingOnLoad = $(".body-content.container-fluid").css("padding-top");
	var breadcrumbPaddingOnLoad = $(".breadcrumb-panel").css("padding-top");

	function calculateAlertBoxHeight() {
		var targetAlert = $(".body-wrapper .a17-alert").first();
		if (targetAlert.length > 0 && !$(targetAlert).is(":visible")) {
			targetAlert = $(".cookie-consent-warning").first();
		}

		var alertboxHeight = $(targetAlert).is(":visible") ? targetAlert.height() : 0;

		var targetHeader = $(".fixed-nav-header");

		if (targetAlert.length > 0 && targetHeader.length > 0 && alertboxHeight > 0) {
			var navTopBarHeight = $(".nav-top-bar").height();
			var fixedHeaderHeight = alertboxHeight + navTopBarHeight;
			var fixedHeaderHeightMobile = fixedHeaderHeight - 10;
			var windowWidth = $(window).width();
			var topValue = windowWidth <= 575 ? fixedHeaderHeightMobile : fixedHeaderHeight;
			$(".fixed-nav-header").css("top", topValue);
			targetAlert.css({
				"position": "fixed",
				"top": "0",
				"z-index": "10"
			});
		}
	}

	function fixedHeaderalertWidth() {
		if ($(window).width() > 1400) {
			$(".fixed-nav-header").siblings(".a17-alert").first().css("width", "1400");
		} else {
			$(".fixed-nav-header").siblings(".a17-alert").first().css("width", "100%");
		}
	}
	$(window).resize(function () {
		calculateAlertBoxHeight();
		fixedHeaderalertWidth();
	});
	$(document).ready(function () {
		setTimeout(function () {
			if ($(".fixed-nav-header") && $(".fixed-nav-header").length) {
				$('.fixed-nav-header').css('position', 'fixed');
				$(".body-content.container-fluid").css("top", containerPaddingOnLoad);
				$(".breadcrumb-panel").css("padding-top", breadcrumbPaddingOnLoad);
				fixedHeader();
			}
			calculateAlertBoxHeight();
		}, 1000);		
		fixedHeaderalertWidth();
	});
	//7619-  for scroll in dropdown class
	$(document).ready(function () {
		var headdata = $(".icon-nav-header.fixed-nav-header");
		var headdataNoIcon = $(".navbar-main-header.fixed-nav-header");
		var dropdownWidth = $(window).width();

		// for headers with icon and dropdownclass
		if (headdata.length > 0) {
			$(".nav-meganav-col").closest(".dropdown-menu").css({
				"max-height": '70vh',
				"overflow-y": "auto",
				"overflow-x": "hidden"
			});
		}
		// for headers without icon and dropdownclass
		if (headdataNoIcon.length > 0) {
			$(".nav-meganav-col").closest(".dropdown-menu").css({
				"max-height": '70vh',
				"overflow-y": "auto",
				"overflow-x": "hidden"
			});
		}
		// for headers with section
		if (headdataNoIcon.length > 0) {
			$(".nav-meganav-col").closest("section.nav-meganav").css({
				"max-height": '70vh',
				"overflow-y": "auto",
				"overflow-x": "hidden"
			});
		}


	});

	$(window).resize(function () {
		if ($(".fixed-nav-header") && $(".fixed-nav-header").length) {
			$('.fixed-nav-header').css('position', 'fixed');
			setTimeout(function () {
				if ($('.nav-main-list-trigger.nav-main-item-active').length && ($('.fixed-nav-header') && $('.fixed-nav-header').length)) {
					$('.fixed-nav-header').css('position', 'relative');
				} else {
					if (!($('.nav-main-list-trigger.nav-main-item-active').length) && ($('.fixed-nav-header') && $('.fixed-nav-header').length)) {
						$('.fixed-nav-header').css('position', 'fixed');
					}
				}
				// 7619 
				if ($(window).width() <= 991) {
					if ($('.nav-main-list-trigger.nav-main-item-active').length && ($('.fixed-nav-header') && $('.fixed-nav-header').length)) {
						$('.fixed-nav-header').css('position', 'fixed');
					} else {
						if (!($('.nav-main-list-trigger.nav-main-item-active').length) && ($('.fixed-nav-header') && $('.fixed-nav-header').length)) {
							$('.fixed-nav-header').css('position', 'fixed');
						}
					}
				} else {
					$('.fixed-nav-header').css('position', 'fixed');
				}
			}, 1000);

			$(".body-content.container-fluid").css("padding-top", containerPaddingOnLoad);
			$(".breadcrumb-panel").css("padding-top", breadcrumbPaddingOnLoad);
			fixedHeader();
		}
	});

	function fixedHeader() {
		var headerHeight = $(".fixed-nav-header").height();
		var paddingContainer = parseInt($(".body-content.container-fluid").css("padding-top"));
		var paddingBreadcrumb = parseInt($(".breadcrumb-panel").css("padding-top"));
		var alertBox = $(".body-wrapper").find(".a17-alert:visible");
		var alertBoxHeight = alertBox.length > 0 ? alertBox.height() : 0;
		var navTopBarHeight = $(".nav-top-bar").height();
		if (($("nav").hasClass("breadcrumb-panel")) == false) {
			var headerHeight1 = headerHeight + paddingContainer;
			$(".body-content.container-fluid").css("top", headerHeight1);
			$(".body-content.container-fluid").css("margin-bottom", headerHeight1);
		}
		else {
			if ($(".breadcrumb-panel").offsetParent().hasClass("fixed-nav-header") == true) {
				var headerHeight2 = headerHeight + paddingContainer;
				$(".body-content.container-fluid").css("top", headerHeight2);
				$(".body-content.container-fluid").css("margin-bottom", headerHeight2);
			} else if ($("nav").parents().find(".a17-alert").length) {
				if ($(".a17-alert").is(":visible")) {
					var headerHeight3 = headerHeight + navTopBarHeight + alertBoxHeight;
					var headerHeightMobile3 = headerHeight + navTopBarHeight + alertBoxHeight - 10;
					if ($(window).width() <= 575) {
						$(".breadcrumb-panel").css("top", headerHeightMobile3);
					} else {
						$(".breadcrumb-panel").css("top", headerHeight3);
					}
				} else {
					$(".breadcrumb-panel").css("top", headerHeight);
				}

			}
			else {
				var headerHeight6 = headerHeight + paddingBreadcrumb;
				$(".breadcrumb-panel").css("top", headerHeight6);
			}
		}
		if (($("nav").parents().find(".a17-alert").length && $("nav").parents().find(".navbar-main-header.fixed-nav-header").length == 1)) {
			var headerHeight4 = headerHeight + alertBoxHeight + navTopBarHeight;
			$(".body-content.container-fluid").css("top", headerHeight4);
			$(".body-content.container-fluid").css("margin-bottom", headerHeight4);
		}
		if (($("nav").parents().find(".a17-alert").length && $("nav").parents().find(".navbar-main-header.fixed-nav-header").length == 0)) {
			if ($(".a17-alert").is(":visible")) {
				var headerHeight5 = headerHeight + paddingContainer + alertBoxHeight + navTopBarHeight;
				$(".body-content.container-fluid").css("top", headerHeight5);
				$(".body-content.container-fluid").css("margin-bottom", headerHeight5);
			} else {
				var headerHeight7 = headerHeight + paddingContainer + alertBoxHeight;
				$(".body-content.container-fluid").css("top", headerHeight7);
				$(".body-content.container-fluid").css("margin-bottom", headerHeight7);
			}

		}

	}
	$('.nav-icon-trigger').click(function () {
		if ($('header').hasClass('fixed-nav-header')) {
			if ((($('.nav-icon-trigger').attr('aria-expanded')) == 'false') && (($('.navbar-collapse').hasClass('show')) == false)) {
				$('.navbar-collapse').css('max-height', "160px");
				$('.navbar-collapse').css('height', "108px !important");
			}
		}
	});
	$('.nav-main-search-trigger').bind('click', function () {
		if ($('header').hasClass('fixed-nav-header')) {
			if ($('header').find('nav-main-search')) {
				$('.search-box').css('position', 'relative');
				$('.breadcrumb-panel').css('position', 'aboslute');
			}
			else {
				$('.nav-main-search').css('position', 'fixed');
				$('.nav-main-search').css('background', '#fff');

			}
		}
	});


	$('.nav-main-list-trigger').bind('click', function () {
		setTimeout(function () {
			if (($('.nav-main-list-trigger').attr('aria-expanded')) === 'true' || ($('.nav-main-list-trigger').attr('aria-expanded')) === 'undefined') {
				if ($(".breadcrumb-panel").length > 0 && $(".breadcrumb-panel").offsetParent().hasClass("fixed-nav-header") == true) {
					
					calculateAlertBoxHeight();
					fixedHeader();
				}

				else if ($(".breadcrumb-panel").length > 0 && $(".breadcrumb-panel").offsetParent().hasClass("fixed-nav-header") == false) {
					$('.breadcrumb-panel').css('padding-top', "unset");
					calculateAlertBoxHeight();
					fixedHeader();
				}

				else {
					calculateAlertBoxHeight();
					fixedHeader();

				}
			}
			else {
				var headerOnLoad = $(".fixed-nav-header").css("height");
				if ($(".breadcrumb-panel").length > 0 && $(".breadcrumb-panel").offsetParent().hasClass("fixed-nav-header") == true) {
					var paddingOnThumber1 = parseInt(headerOnLoad) + parseInt(containerPaddingOnLoad);
					calculateAlertBoxHeight();
					fixedHeader();
					$('.container-fluid').scrollTop();
				}

				else if ($(".breadcrumb-panel").length > 0 && $(".breadcrumb-panel").offsetParent().hasClass("fixed-nav-header") == false) {
					var paddingOnThumber2 = parseInt(headerOnLoad) + parseInt(breadcrumbPaddingOnLoad);
					$('.breadcrumb-panel').css('padding-top', breadcrumbPaddingOnLoad);
					calculateAlertBoxHeight();
					fixedHeader();
				}

				else {
					$('.container-fluid').scrollTop();
					calculateAlertBoxHeight();
					fixedHeader();
				}

			}
		}, 200);
	});


	var BUFFER = 2; // spacing between logo and main nav to ensure there's no wrapping in edge cases
	var $navMainBar;
	var $navMainList;

	captureElements();
	bindEvents();
	adjustMainMenu();
	copyRightInfo();

	function captureElements() {
		$navMainBar = $('.nav-main-bar');
		$navMainList = $('.nav-main-list');
	}

	function bindEvents() {
		$(document).on('ready', adjustMainMenu);
		$(window).off('resize', adjustMainMenu);
		$(window).on('load resize', adjustMainMenu);
	}

	function adjustMainMenu() {
		$(".nav-main-mobile-panel a").attr("tabindex", "0");
		if (!$navMainBar.is(':visible')) return;
		applyWidth(true);
		var availableWidth = getAvailableWidth() - BUFFER;
		if ($("body").css("overflow") == "hidden") {
			availableWidth = availableWidth - 16;
		}
		else {
			availableWidth = availableWidth;
		}
		var requiredWidth = $navMainList.outerWidth(true);
		var hasEnoughSpace = availableWidth >= requiredWidth;
		applyWidth(hasEnoughSpace, availableWidth);
	}

	function getAvailableWidth() {
		var consumedWidth = 0;
		$navMainBar.children(':visible').not($navMainList).each(function () {
			consumedWidth += $(this).outerWidth(true);
		});
		return $navMainBar.width() - consumedWidth;
	}

	function applyWidth(hasEnoughSpace, width) {
		$navMainList.toggleClass('nav-main-list-condensed', !hasEnoughSpace);
		$navMainList.css('max-width', hasEnoughSpace ? '' : width);
	}

	function copyRightInfo() {
		if ($('.replaceyear').length) {
			var today = new Date();
			var year = today.getFullYear();
			$('.replaceyear').html(year);
		}
	}

	$(document).ready(function () {
		if ($('.skip-link') && $('.skip-link').length) {
			var skip = document.getElementById("skip");
			skip.onkeyup = function (e) {
				if (e.keyCode == 32) {
					skip.click();
				}
			};

		}

		$(document).ready(function () {
			setNavLinkHgtToMaxLinkHgt();
		});
		$(window).off('load resize', function () {
			setNavLinkHgtToMaxLinkHgt();
		});
		$(window).on('load', function () {
			setNavLinkHgtToMaxLinkHgt();
		});
		$(window).on('resize', function () {
			setNavLinkHgtToMaxLinkHgt();
		});
		function getHeight(element) {
			return parseInt(element.css('height'));
		}
		function setNavLinkHgtToMaxLinkHgt() {
			var width = $(document).width();
			if (width >= 992) {
				$(".icon-nav-header .navbar .nav-item .nav-link.dropdown-toggle").css('height', 'auto');
				var height = 0;
				$(".icon-nav-header .navbar .nav-item .nav-link.dropdown-toggle").each(function () {

					height = Math.max(height, getHeight($(this)));
				});
				$(".icon-nav-header .navbar .nav-item .nav-link.dropdown-toggle").each(function () {
					$(this).css('height', height);
				});
				$(".icon-nav-header .nav-main-item.nav-main-search-trigger").css('height', height);

			}
		}


	});
	$(".nav-main-mobile-panel a").click(function () {
		setTimeout(function () {
			if ($(".nav-main-mobile-panel").hasClass("nav-main-mobile-panel-active")) {

				if ($(".nav-main-mobile-panel-active li a:nth-child(2)").hasClass("linknavigation")) {

					$(".nav-main-mobile-panel-active li a.backnavigation").children("span").css("display", "none");
				} else {

					$(".nav-main-mobile-panel-active li a.backnavigation").children("span").css("display", "block");
				}
			}
		}, 50);
	});

}(window.jQuery));


// Analytic
analytics.eventConfig.push({
	"target": ".component.a17-alert",
	"codeId": "a17",
	"events": [
		{
			"eventTarget": "a[href*=\\http]",
			"eventType": "click",
			"tags": {
				"componentId": "a17",
				"componentName": "alert",
				"destinationUrl": "",
				"elementText": "",
				"elementType": "alert link",
				"event": [
					{
						"rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
						"value": "download"
					},
					{
						"rule": "true",
						"value": "outbound"
					}
				],
				"eventType": [
					{
						"rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
						"value": "pds download click"
					},
					{
						"rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
						"value": "sds download click"
					},
					{
						"rule": "true",
						"value": "outbound click"
					}
				],
				"fileName": "",
				"titleText": ".alert .alert-title"
			}
		},
		{
			"eventTarget": "a:not([href*=\\http])",
			"eventType": "click",
			"tags": {
				"componentId": "a17",
				"componentName": "alert",
				"destinationUrl": "",
				"elementText": "",
				"elementType": "alert link",
				"event": [
					{
						"rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
						"value": "contact"
					},
					{
						"rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
						"value": "download"
					},
					{
						"rule": "true",
						"value": "navigation"
					}
				],
				"eventType": [
					{
						"rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
						"value": "click to email"
					},
					{
						"rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
						"value": "other media asset click"
					},
					{
						"rule": "true",
						"value": "alert internal navigation click"
					}
				],
				"fileName": "",
				"titleText": ".alert .alert-title"
			}
		}
	]
});